import _ from 'underscore';

export default function select(local, attrs, custom) {
  if (!_.contains(custom.values, local())) {
    local(custom.values[0]);
  }

  local.select = attrs.type === 'string' ? local : local.string;
}
